import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import { HttpEvent, HttpRequest, HttpResponse } from '@angular/common/http';
import {
  CreditLiabilityResponse,
  NotificationHealthResponse,
  OverduePaymentsResponse,
} from '@app/core/models/dashboard.interface';

@Injectable({ providedIn: 'root' })
export class DashboardMocksService {
  private readonly mockOverduePayments: OverduePaymentsResponse = {
    count: 4,
    items: [
      {
        invoiceId: 12,
        invoiceNumber: 'INV-01-12',
        customerId: 3,
        customerName: 'John Smith',
        vehicleRego: 'ABC123',
        total: 450.0,
        balance: 450.0,
        createdAt: '2026-02-21T10:00:00.000Z',
        daysOverdue: 14,
      },
      {
        invoiceId: 8,
        invoiceNumber: 'INV-01-08',
        customerId: 5,
        customerName: 'Sarah Wilson',
        vehicleRego: 'XYZ789',
        total: 1200.0,
        balance: 1200.0,
        createdAt: '2026-02-26T09:00:00.000Z',
        daysOverdue: 9,
      },
      {
        invoiceId: 15,
        invoiceNumber: 'INV-01-15',
        customerId: 7,
        customerName: 'David Lee',
        vehicleRego: 'DEF456',
        total: 320.0,
        balance: 320.0,
        createdAt: '2026-02-28T14:00:00.000Z',
        daysOverdue: 7,
      },
      {
        invoiceId: 21,
        invoiceNumber: 'INV-01-21',
        customerId: 9,
        customerName: 'Mark Taylor',
        vehicleRego: 'MNO987',
        total: 890.0,
        balance: 890.0,
        createdAt: '2026-03-04T11:00:00.000Z',
        daysOverdue: 3,
      },
    ],
  };

  private readonly mockCreditLiability: CreditLiabilityResponse = {
    totalCreditLiability: 3240.5,
    customerCount: 12,
  };

  private readonly mockNotificationHealth: NotificationHealthResponse = {
    runDate: '2026-05-02',
    sent: 87,
    skipped: 23,
    skipBreakdown: {
      NO_MOBILE: 10,
      PDF_NOT_READY: 5,
      NO_EMAIL: 4,
      OPTED_OUT: 3,
      OTHER: 1,
    },
  };

  handleMockRequest(req: HttpRequest<any>): Observable<HttpEvent<any>> {
    if (req.method === 'GET' && req.url.includes('/dashboard/overdue-payments')) {
      return of(new HttpResponse({ status: 200, body: this.mockOverduePayments })).pipe(delay(400));
    }

    if (req.method === 'GET' && req.url.includes('/dashboard/credit-liability')) {
      return of(new HttpResponse({ status: 200, body: this.mockCreditLiability })).pipe(delay(400));
    }

    if (req.method === 'GET' && req.url.includes('/dashboard/notification-health')) {
      return of(new HttpResponse({ status: 200, body: this.mockNotificationHealth })).pipe(
        delay(400)
      );
    }

    throw new Error(`Unsupported mock dashboard request: ${req.method} ${req.url}`);
  }
}
